// extracted by mini-css-extract-plugin
export var section = "styles-module--section--1mXZ4";
export var inner = "styles-module--inner--3S5qD";
export var box = "styles-module--box--3YR8a";
export var videoPlayWrap = "styles-module--videoPlayWrap--AT9C-";